import useFetchData from './useFetchData'
import { getByIdFiltered } from 'services/content-service'

const useGetContentByIdFiltered = (contentType, id, params) =>
  useFetchData(() => getByIdFiltered(contentType, id, params), [contentType, id, params]).data

export default useGetContentByIdFiltered
